<script lang="ts" setup>
import type { MemberManagementFormType } from './formSchema'
import type { Option } from '@/types/app'
import { computed, ref } from 'vue'
import DolphinTextInput from '../../atoms/DolphinTextInput.vue'
import SettingsTableRow from '@/pages/SettingsPage/SettingsTable/SettingsTableRow.vue'
import SettingsTable from '@/pages/SettingsPage/SettingsTable/SettingsTable.vue'
import DolphinSelector from '../../atoms/DolphinSelector.vue'
import FlatButton from '../../atoms/FlatButton.vue'
import type { MemberManagementFormFragment } from './MemberManagemenetForm.generated'
import type { StaffRole } from '@/types/schema.generated'

const props = defineProps<{
  fragment: MemberManagementFormFragment
  isSubmitting: boolean
  initialForm?: MemberManagementFormType
  isEditPage?: boolean
  disableRole?: boolean
}>()

const emit = defineEmits<{
  (event: 'submit', input: MemberManagementFormType): void
}>()

const initialForm: MemberManagementFormType = props.initialForm ?? {
  email: '',
  name: undefined,
  role: 'MEMBER',
}

const displayRole = computed(() =>
  form.value.role === 'ENTRANCE_MANAGER' ? 'アカウント管理者' : '一般'
)

const form = ref({ ...initialForm })

const roleOptions: Option<StaffRole>[] = [
  { value: 'MEMBER', text: '一般' },
  { value: 'ENTRANCE_MANAGER', text: 'アカウント管理者' },
]

const handleSubmit = () => {
  emit('submit', form.value)
}
</script>

<template>
  <SettingsTable is-editing>
    <SettingsTableRow v-if="isEditPage" name="メールアドレス">
      <p>{{ form.email }}</p>
    </SettingsTableRow>
    <SettingsTableRow v-else name="メールアドレス">
      <template #editor>
        <DolphinTextInput
          type="text"
          v-model="form.email"
          :class="$style.textInput"
        />
      </template>
    </SettingsTableRow>
    <SettingsTableRow name="名前">
      <template #editor>
        <DolphinTextInput
          type="text"
          v-model="form.name"
          :class="$style.textInput"
        />
      </template>
    </SettingsTableRow>
    <SettingsTableRow v-if="disableRole" name="権限">
      <p>{{ displayRole }}</p>
    </SettingsTableRow>
    <SettingsTableRow v-else name="権限">
      <template #editor>
        <DolphinSelector :options="roleOptions" v-model="form.role" />
      </template>
    </SettingsTableRow>
  </SettingsTable>
  <div :class="$style.saveWrapper">
    <FlatButton
      size="large"
      @click="handleSubmit"
      :disabled="props.isSubmitting"
    >
      この内容で保存する
    </FlatButton>
  </div>
</template>

<style lang="scss" module>
.textInput {
  width: 100%;
}

.saveWrapper {
  display: flex;
  margin-top: 24px;
  justify-content: center;
}
</style>
